import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
import { ConditionRegistryItem } from '../../ConditionRegistryItem';
export class ConditionRegistryRuntimeKeyboard extends ConditionRegistryCategory {
    label = 'Tastatur';
    constructor(parent) {
        super(parent);
        super.init();
    }
    isKeyPressed = () => new ConditionRegistryItem({
        eval: ({ runtime, evaluator }) => !!evaluator.valueOf.keyboardKey && runtime.keyboard.isKeyPressed(evaluator.valueOf.keyboardKey),
        /*   label: 'ist Taste gedrückt',
          params: { core: ['keyboardKey'] }
          /* struct: ({ evaluator }) => (
            <span>
              Ist Taste "<span style={{ fontSize: 20 }}>{evaluator.valueOf.keyboardKey}</span>" gedrückt [{keys(
                runtime.keyboard.currentKeyDown
              ).join(', ')}]
            </span>
          ) */
    });
}
